// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string|number} value
 * @param {boolean} validationValue
 * @returns {boolean}
 */
function businessId ({ value, validationValue }) {
  if (!validationValue) return true

  if (process.env.NODE_ENV !== 'production') {
    return [
      '0000000-0',
      '1111111-1',
      '2222222-2',
      '3333333-3',
      '4444444-4',
      '5555555-5',
      '6666666-6',
      '7777777-7',
      '8888888-8',
      '9999999-9'
    ].indexOf(value) !== -1
  }

  const val = value.replace('-', '')
  /* istanbul ignore next */
  if (!/\d{8}/.test(val)) return false

  const id = val.substr(0, 7)
  const checksum = Number(val.charAt(7))
  const totalCount = [7, 9, 10, 5, 8, 4, 2].reduce((acc, multiplier, index) => {
    return acc + multiplier * Number(id[index])
  }, 0)
  const remainder = totalCount % 11

  /* istanbul ignore next */
  switch (remainder) {
    case 1:
      return false
    case 0:
      return checksum === remainder
    default:
      return checksum === 11 - remainder
  }
}

module.exports = { businessId }
